import styled, { css } from 'styled-components'

import { defaultTheme } from '@/styles/themes'

type InputProps = {
  darkMode?: boolean
  error?: boolean
}
type LabelProps = {
  darkMode?: boolean
}
type WrapperProps = {
  width?: string
}

export const Input = styled.input<InputProps>`
  background: transparent;

  outline: none;
  border-width: 0 0 2px;
  border-color: ${({ darkMode, theme }) =>
    darkMode ? theme.colors.white : theme.colors.darkgray};

  color: ${({ darkMode, theme }) =>
    darkMode ? theme.colors.white : theme.colors.darkgray};

  font-size: 16px;
  font-weight: 400;

  width: 100%;

  ${({ error }) =>
    error &&
    css`
      border-color: ${defaultTheme.colors.red};
    `}

  :focus {
    border-color: ${defaultTheme.colors.primary_1};
    caret-color: ${defaultTheme.colors.primary_1};
  }

  ::placeholder {
    color: ${defaultTheme.colors.lightgray};
    font-size: 16px;
    line-height: 20px;
  }
`

export const Label = styled.label<LabelProps>`
  font-size: 12px;
  font-weight: 400;
  color: ${({ darkMode, theme }) =>
    darkMode ? theme.colors.white : theme.colors.darkgray};
`

export const Wrapper = styled.div<WrapperProps>`
  width: ${({ width }) => width || '100%'};
  margin-bottom: 1.5rem;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 3rem;
`

export const Error = styled.span`
  font-size: 12px;
  color: ${defaultTheme.colors.red};
`
